import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth.jsx';

export function RouteGuard({ roles, children }) {
    const { user } = useAuth();
    const loc = useLocation();
    if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
    if (roles && !roles.includes(user.role)) {
        return <Navigate to={user.role === 'instructor' ? '/instructor/dashboard' : user.role === 'parent' ? '/parent/dashboard' : '/admin/dashboard'} replace />;
    }
    return children;
}
